import React from "react";
import { transactionType } from "../../Page/TransactionSummaryPage/Shared/Constants";
import { setLabels } from "./helper/GeneralDetailsHelper";
const GeneralDetails = ({ generalDetails, data, offerName, dealType, reasonCode }) => {
  const showComponent = true; //checkSectionValid(generalDetails);
  const title =
    data.generalDetailsTopic.value === ""
      ? "פרטי הזמנה"
      : data.generalDetailsTopic.value;

  let labels = {};
  if (showComponent) {
    labels = setLabels(dealType, reasonCode);
  }

  return showComponent ? (
    <div className="general-details">
      <label className="general-details__topic">{title}</label>
      <div className="content-collapse-container">
        <div className="general-details__content">
          <div className="general-details__row">
            {dealType !== transactionType.Accessory && (
              <div className="general-details__holder">
                <label>שם התוכנית</label>
                <span>{offerName ? offerName : generalDetails.offerName}</span>
              </div>
            )}
            <div className="general-details__holder">
              <label>{labels.saleDate}</label>
              <span>{generalDetails.saleDate}</span>
            </div>
          </div>
          <div
            className={
              "general-details__row " +
              (dealType === transactionType.Disconnect
                ? "general-details__row--bg-purple"
                : "")
            }
          >
            <div className="general-details__holder">
              <label>{labels.orderNumber}</label>
              <span>{generalDetails.orderNumber}</span>
            </div>
            {dealType !== transactionType.Accessory && (
              <div className="general-details__holder">
                <label>מועד סגירת החשבונית</label>
                <span>{"ב- " + generalDetails.billCycle + " לכל חודש"}</span>
              </div>
            )}
          </div>
        </div>
        {data.generalDetailsMessage.value !== "" && (
          <p className="general-details__message">
            {data.generalDetailsMessage.value}
          </p>
        )}
      </div>
    </div>
  ) : null;
};

export default GeneralDetails;
